// removed by extract-text-webpack-plugin
module.exports = {"row":"style-row-34952488","col":"style-col-cd526473","button":"style-button-ec00560b","bannerAd":"style-bannerAd-f7e7b9a4","rail":"style-rail-c12a251f","marketingPermission":"style-marketingPermission-e6167bf0","checkbox":"style-checkbox-57727fee"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MarketingPermission/style.scss
// module id = 870
// module chunks = 0